import React, { useEffect, useCallback, useState} from 'react';
import ParameterBox from 'components/instruments/ParameterBox.js';
import {AbstractParameter} from "parameters/AbstractParameter.js";
import {connect} from 'react-redux';

const Royalties = ({royalties}) => { 
    return (
        <div className="royalties zora-field focused">
          <div className="field-name">
            your royalties %
          </div>
          {royalties && <ParameterBox units="%" width={200} parameter={royalties}/>}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Royalties);
